var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"sap-badge-wrapper d-inline-flex align-center"},'div',attrs,false),on),[_c('div',{staticClass:"bg-sap sap-badge d-inline-block"})])]}}])},[_vm._v(" SAP ")])}
var staticRenderFns = []

export { render, staticRenderFns }